export default "__VITE_ASSET__D22UPI9U__"